/* eslint-disable ember/no-controller-access-in-routes, warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class IndexRoute extends Route {
  // Services
  @service
  store;

  @service
  router;

  model() {
    return hash({
      goalSubjects: this.store.query('goals/subject', {
        trackable: true,
      }),
    });
  }

  afterModel() {
    super.afterModel(...arguments);

    // Redirect to the first subject in the list/already selected subject,
    // so that there's content to display.
    let params = this.paramsFor('group');
    let subjectId = this.controllerFor('group/insights/progress').get(
      'subjectId',
    );
    this.router.transitionTo(
      'group.insights.progress.rates.subject',
      params.group_id,
      subjectId,
    );
  }
}
